"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSchema = exports.OGroups = exports.OGroupWithConsultants = exports.OGroup = exports.IGroup = void 0;
const mongoose_1 = __importDefault(require("mongoose"));
const runtypes_1 = require("runtypes");
const misc_1 = require("./misc");
const consultants_1 = require("./consultants");
exports.IGroup = (0, runtypes_1.Record)({ name: runtypes_1.String });
exports.OGroup = exports.IGroup.extend({
    id: misc_1.ID,
});
exports.OGroupWithConsultants = exports.OGroup.extend({
    consultants: (0, runtypes_1.Array)(consultants_1.OConsultant),
});
exports.OGroups = (0, runtypes_1.Array)(exports.OGroup);
exports.GroupSchema = new mongoose_1.default.Schema({
    name: { type: String, required: true, unique: true },
});
